module.exports = __webpack_public_path__ + "static/img/icon_del.98232a2e.png";